<div class="tv" *ngIf="lathato && k" [class.sotet]="sotet">
  <div class="tv-cim">Téma</div>
  <div class="tv-gombok" role="radiogroup" aria-label="A modul témája">
    <button type="button" *ngFor="let t of temak" role="radio"
            [attr.aria-checked]="k.tema() === t.kod" [class.aktiv]="k.tema() === t.kod"
            [title]="t.leiras" (click)="valaszt(t.kod)">
      <ion-icon [name]="t.ikon"></ion-icon>
      <span>{{ t.nev }}</span>
      <small *ngIf="k.kijeloltTema() === t.kod" class="tv-jel">kijelölt</small>
    </button>
  </div>
  <div class="tv-proba" *ngIf="proba">
    <span>Kipróbálás – csak nálad látszik. A modul témája: <b>{{ kijeloltNev }}</b>.</span>
    <div class="tv-muvelet">
      <button type="button" class="tv-ment" [disabled]="fut" (click)="ment()">
        <ion-icon name="checkmark-done-outline"></ion-icon> Legyen ez a modul témája
      </button>
      <button type="button" class="tv-vissza" [disabled]="fut" (click)="k.temaProba(null)">Vissza</button>
    </div>
  </div>
</div>
